import { GridLocation } from './GridLocation';

export type { TypeGridLocationProps } from './types';
export default GridLocation;
